















import { defineComponent } from "@vue/composition-api";
import LocaleSwitch from "@/components/LocaleSwitch";
import LandingCreatorsCommitment from "./components/LandingCreatorsCommitment.vue";
import LandingCreatorsFaq from "./components/LandingCreatorsFaq.vue";
import LandingCreatorsFooter from "./components/LandingCreatorsFooter.vue";
import LandingCreatorsHero from "./components/LandingCreatorsHero.vue";
import LandingCreatorsHowToApply from "./components/LandingCreatorsHowToApply.vue";
import LandingCreatorsSuccessStories from "./components/LandingCreatorsSuccessStories.vue";
import LandingCreatorsWhyJoin from "./components/LandingCreatorsWhyJoin.vue";

export default defineComponent({
  name: "PageLandingCreators",
  components: {
    LocaleSwitch,
    LandingCreatorsFooter,
    LandingCreatorsWhyJoin,
    LandingCreatorsSuccessStories,
    LandingCreatorsFaq,
    LandingCreatorsHowToApply,
    LandingCreatorsCommitment,
    LandingCreatorsHero,
  },
});
